export enum ActionTypeE {
  AiAgent = 'ai_agent',
  Config = 'config',
  SendMessage = 'send_message',
  SendSms = 'send_sms',
  SendFile = 'send_file',
  RequestInfo = 'request_info',
  RunFlow = 'run_flow',
  RunAction = 'run_action',
  Transfer = 'transfer',
  SendFeedback = 'send_feedback',
  CheckTeamAvailability = 'check_team_availability',
  Condition = 'conditional',
  ConditionTemplate = 'conditional_template',
  SendProtocol = 'send_protocol',
  FinishAttendance = 'finish_attendance',
  CheckAttendanceHoursTeam = 'check_attendance_hours_team',
  Integration = 'integration',
  AddHorary = 'add_horary',
  SendTemplate = 'send_template',
  SendEmail = 'send_email',
  Resume = 'resume',
  Authentication = 'authentication',
  Webhook = 'webhook',
  WebhookDynamicConditional = 'webhook_dynamic_conditional',
  WebhookUpdateContact = 'webhook_update_contact',
  ConditionalLogic = 'conditional_logic',
  BlockContact = 'block_contact',
  SetVariable = 'set_variable',
  // Ações de jornada (trazidas do Workflow para o Flow — aditivas)
  Wait = 'wait',
  AddTag = 'add_tag',
  RunWorkflow = 'run_workflow',
  OpenExternalChat = 'open_external_chat',
  SendForm = 'send_form',
}

export enum TypeTransferE {
  Agent = 'agent',
  Team = 'team',
}
